module.exports = "/images/vendor/vue-paycard/src/jcb.png?56cb51fb369da5140fcba12dc6051687";